const resource = 'venues';

export default $axios => ({
    getVenues(params = {}) {
        return $axios.get(`/${resource}`, { params });
    },
    getVenue(id, params = {}) {
        return $axios.get(`/${resource}/${id}`, { params });
    },
    getProducts(id, params = {}) {
        return $axios.get(`/${resource}/${id}/products`, { params });
    },
    getCategories(id, params = {}) {
        return $axios.get(`/${resource}/${id}/categories`, { params });
    },
    createVenue(venueData) {
        return $axios.post(`/${resource}`, venueData);
    },
    updateVenue(venueData) {
        return $axios.put(`/${resource}/${venueData.id}`, venueData);
    },
    updateVenueCampaignAssignment(venue, campaign, params = {}) {
        return $axios.put(
            `/${resource}/${venue}/campaigns/${campaign}`,
            params
        );
    },
    updateVenueProductCampaignAssignment(venue, product, campaign, params = {}) {
        return $axios.put(
            `/${resource}/${venue}/products/${product}/campaigns/${campaign}`,
            params
        );
    },
    getVenueMedia(venueId) {
        return $axios.get(`/${resource}/${venueId}/media`);
    },
    assignVenueMedia(venueId, mediaData) {
        return $axios.post(`/${resource}/${venueId}/media`, {
            media_id: mediaData.id,
            location: mediaData.location
        });
    },
    updateVenueMedia(venueId, assignmentId, mediaData) {
        return $axios.put(`/${resource}/${venueId}/media/${assignmentId}`, {
            media_id: mediaData.id,
            location: mediaData.location
        });
    },
    deleteVenueMedia(venueId, id) {
        return $axios.delete(`/${resource}/${venueId}/media/${id}`);
    },
    getMobilePassReviewLink(venueId, productId=false) {
        const params = {};
        if( productId )
            params.productId = productId;

        return $axios.get(`/${resource}/${venueId}/previewLink`, {params});
    },
    getMobilePassReviewLinkCampaign(venueId, campaignId, productId=false) {
        const params = {};
        if( productId )
            params.productId = productId;

        return $axios.get(`/${resource}/${venueId}/campaigns/${campaignId}/previewLink`, {params});
    },
    getVenueProducts(venue, params={}) {
        return $axios.get(`${resource}/${venue}/products`, { params });
    },
    getVenueCampaigns(venue, campaignId = null){
        return $axios.get(`/${resource}/${venue}/campaigns/${campaignId}`);
    },
    getDeals(venueId) {
        return $axios.get(`/${resource}/${venueId}/deals`)
    },
});
